<template>
  <v-footer class="pa-3">
    <div class="ftr">&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>
export default {};
</script>

<style>

.ftr{
  margin: 0 auto;
}
</style>
